import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

// start : profile

export function changePassword(params) {
  return authPost(`${baseUrl}/Agent1.ashx`, params);
}

// export function changeLanguage(params) {
//   return authPost(`${baseUrl}/Member2/ChangeLanguage`, params);
// }

// end : profile
